export default __webpack_public_path__ + "static/media/Metropolis-Regular.d6363f82.woff";